<template>
  <div class="container">
    <div class="handle-wrapper">
      <Input
        v-model="searchText"
        search
        placeholder="搜索复配中心..."
        @on-change="searchSac"
        style="width: 250px; margin-right: auto"
      >
        <Button slot="append" icon="ios-search" @click="searchSac"></Button>
      </Input>
      <span>共{{ totalRows }}条</span>
      <Page
        :total="totalRows"
        :page-size="15"
        @on-change="loadSac"
        show-total
        simple
        style="margin-right: 24px"
      />
      <Button type="primary" @click="$refs.EditSACDrawer.openDrawer()"
        >新增SAC</Button
      >
    </div>
    <div class="table-wrapper" ref="tableWrapper">
      <Table
        :loading="tableLoading"
        :columns="columns"
        :data="tableData"
        :height="tableHeight"
      ></Table>
    </div>
    <EditSACDrawer ref="EditSACDrawer" />
  </div>
</template>

<script>
import EditSACDrawer from "./EditSACDrawer.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Sac",
  components: { EditSACDrawer },
  props: {},
  data() {
    return {
      page: 0,
      searchText: "",
      tableLoading: false,
      tableHeight: 300,
      columns: [
        {
          title: "名字",
          key: "name",
          render: (h, params) => {
            return h("div", [
              h(
                "h4",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    color: "#42b983",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push(`/home/sac/${params.row._id}`);
                    },
                  },
                },
                params.row.name
              ),
            ]);
          },
        },
        {
          title: "短号",
          key: "NoId",
          render: (h, params) => h("span", params.row.NoId),
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tableData: (state) => state.sac.sacsList,
      totalRows: (state) => state.sac.totalCounts,
    }),
  },
  methods: {
    ...mapActions({
      getSacsList: "sac/getSacsListAction",
    }),
    async loadSac(page) {
      if (page) this.page = page - 1;
      let api = { skip: this.page * 15, limit: 15 };
      if (this.searchText) api.searchText = this.searchText;

      try {
        this.tableLoading = true;
        await this.getSacsList(api);
        this.tableLoading = false;
      } catch (error) {
        this.$Message.error(`加载失败: ${error}`);
        this.tableLoading = false;
      }
    },
    searchSac() {
      this.page = 0;
      this.loadSac();
    },
  },
  created() {
    this.loadSac();
  },
  mounted() {
    this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    window.onresize = () => {
      this.tableHeight = this.$refs.tableWrapper.offsetHeight;
    };
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped lang="stylus">
.handle-wrapper
  width 100%
  height 48px
  display flex
  align-items center
  justify-content flex-end

.table-wrapper
  width 100%
  height calc(100% - 48px)
</style>
